import React from 'react'
import { Field } from 'redux-form'
import PropTypes from 'prop-types'

import Money from '@cred/react-basic-form-fields/reduxForm/Money'

const MoneyInputRedux = (props) => {
  const { className = '', exposeValue = false, ...rest } = props

  return <Field component={Money} className={className} sensitive={!exposeValue} {...rest} />
}

MoneyInputRedux.propTypes = {
  className: PropTypes.string,
  exposeValue: PropTypes.bool,
}

export default MoneyInputRedux
